// @ts-expect-error - js module
import { actionShape } from '@/utils/transformFrontendAction';
import { patientShape } from '@/utils/transformFrontendPatient';
import useGetContextualInfo from '@/pages/TaskBasedWorkflow/hooks/useGetContextualInfo';
// @ts-expect-error - js module
import FieldSkeleton from '@/pages/TaskBasedWorkflow/components/taskTableView/FieldSkeleton';
import { Action, Patient } from '@/utils/types';
// @ts-expect-error - js module
import OutreachLogModal from '@/pages/TaskBasedWorkflow/components/patientDetailView/OutreachLogModal';

export default function LastOutreachDate({
  action,
  patient,
}: {
  action: Action;
  patient: Patient;
}) {
  const { data: contextualInfo, isSuccess } = useGetContextualInfo(action);

  const modalTriggerText =
    contextualInfo?.lastOutreachDate === '--'
      ? 'none in last 30 days'
      : contextualInfo?.lastOutreachDate;

  const firstName = patient?.firstName ?? '';
  const lastName = patient?.lastName ?? '';
  const patientName = `${firstName} ${lastName}`.trim(); // Use trim to handle cases where one name is empty

  return !isSuccess || !patient ? (
    <FieldSkeleton />
  ) : (
    <OutreachLogModal
      patientId={patient?.id}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
      patientName={patientName}
      patientPhone={patient?.address?.phoneNumber}
      modalTriggerText={modalTriggerText}
    />
  );
}

LastOutreachDate.propTypes = {
  action: actionShape.isRequired,
  patient: patientShape.isRequired,
};
